/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Tab Scrollbar Functionality
   * Handles horizontal scrolling of tabs on mobile and desktop
   */
  function initTabScrollbar() {
    const scrollBars = document.querySelectorAll('[data-scrollbar]');

    scrollBars.forEach(function(scrollBar) {
      const prevButton = scrollBar.closest('[data-tabs-holder]')?.querySelector('[data-scrollbar-arrow-prev]');
      const nextButton = scrollBar.closest('[data-tabs-holder]')?.querySelector('[data-scrollbar-arrow-next]');

      if (!prevButton || !nextButton) return;

      function updateArrowVisibility() {
        const scrollLeft = scrollBar.scrollLeft;
        const scrollWidth = scrollBar.scrollWidth;
        const clientWidth = scrollBar.clientWidth;

        // Show/hide prev button
        prevButton.classList.toggle('is-hidden', scrollLeft <= 0);

        // Show/hide next button
        nextButton.classList.toggle('is-hidden', scrollLeft >= scrollWidth - clientWidth - 5);
      }

      // Update arrows on scroll
      scrollBar.addEventListener('scroll', updateArrowVisibility);

      // Prev button click handler
      prevButton.addEventListener('click', function() {
        scrollBar.scrollBy({
          left: -200,
          behavior: 'smooth'
        });
      });

      // Next button click handler
      nextButton.addEventListener('click', function() {
        scrollBar.scrollBy({
          left: 200,
          behavior: 'smooth'
        });
      });

      // Initial check
      updateArrowVisibility();

      // Update on window resize
      window.addEventListener('resize', updateArrowVisibility);

      // Update on content change
      const observer = new ResizeObserver(updateArrowVisibility);
      observer.observe(scrollBar);
    });
  }

  /**
   * Tab Click Handler
   * Manages tab switching and content visibility
   */
  function initTabs() {
    const tabsHolders = document.querySelectorAll('[data-tabs-holder]');

    tabsHolders.forEach(function(holder) {
      const tabLinks = holder.querySelectorAll('[data-tab]');
      const tabContents = holder.querySelectorAll('[data-tab-index]');

      tabLinks.forEach(function(tabLink) {
        tabLink.addEventListener('click', function(e) {
          e.preventDefault();
          
          const tabIndex = this.getAttribute('data-tab');
          
          // Remove current class from all tabs
          tabLinks.forEach(function(link) {
            link.classList.remove('current');
            link.setAttribute('tabindex', '-1');
          });

          // Remove current class from all content
          tabContents.forEach(function(content) {
            content.classList.remove('current');
          });

          // Add current class to clicked tab
          this.classList.add('current');
          this.setAttribute('tabindex', '0');

          // Add current class to corresponding content
          const activeContent = holder.querySelector('[data-tab-index="' + tabIndex + '"]');
          if (activeContent) {
            activeContent.classList.add('current');
          }
        });

        // Keyboard support (Enter and Space)
        tabLink.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      });
    });
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initTabScrollbar();
        initTabs();
      });
    } else {
      initTabScrollbar();
      initTabs();
    }
  }

  // Run initialization
  init();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
